import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-global-supplier-config',
  standalone: false,
  templateUrl: './global-supplier-config.component.html'
})
export class GlobalSupplierConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;

  constructor() { }

  ngOnInit() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'global-supplier',
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'globalSupplierId', header: 'Global Supplier ID', type: ColumnType.String, isReadonly: true, isPrimary: true, notInForm: true  },
        { field: 'supplierName', header: 'Supplier Name', type: ColumnType.String },
        { field: 'invoiceSupplierName', header: 'Invoice Supplier Name', type: ColumnType.String }
      ],
      addFormConfig: {
        header: 'Add Global Supplier'
      },
      isConfigurable: true
    };

  }
}
